var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStraighten = function SvgStraighten(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 20.5q0 .6-.45 1.05T16.5 22h-9q-.576 0-1.037-.45Q6 21.1 6 20.5v-17q0-.6.463-1.05Q6.925 2 7.5 2h9q.6 0 1.05.45T18 3.5zm-1.5 0v-17h-9v3.25H12v1.5H7.5v3H12v1.5H7.5v3H12v1.5H7.5v3.25z"
  })));
};
export default SvgStraighten;